import { Provider } from '@oriola-corporation/kronan-icons';
import React from 'react';
import { KeyboardNavigationProvider } from '../contexts/keyboardNavigation';
import { ElementObserverProvider } from '../hooks/useElementObserver';
import { ThemeProvider } from './ThemeProvider';

type Props = React.ComponentProps<typeof ThemeProvider>;

export const RootThemeProvider: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, ...rest }) => (
  <ThemeProvider {...rest}>
    <KeyboardNavigationProvider>
      <Provider value={{ style: { verticalAlign: 'text-top' } }}>
        <ElementObserverProvider>{children}</ElementObserverProvider>
      </Provider>
    </KeyboardNavigationProvider>
  </ThemeProvider>
);
